export default {
	"scanPay.FailedToGenerateOrder": "生成订单失败",
	"scanPay.paymentSuccessful": "支付成功",
	"scanPay.Purchases": "购买商品：",
	"scanPay.OrderNumber": "订单编号：",
	"scanPay.TheAmountActuallyPaid": "实付金额："
}